import axiosInstance from "../lib/axiosInstance";


const Baseurl = process.env.REACT_APP_API_URL


const addressModel = class {

    async GetAddress() {
        return await axiosInstance.get(Baseurl +`/address`);
    }
    async AddAddress(data=[]) {
        return await axiosInstance.post(Baseurl +`/address`,data);
    }
    async DeleteAddress(id) {
        return await axiosInstance.delete(Baseurl +`/address/${id}`);
    }
     async GetpaticularAddress(id) {
        return await axiosInstance.get(Baseurl +`/address/${id}`);
    }
}

export default new addressModel();